// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../../Commons/properties/Resources.js";
import { DataCacheToolRayType, DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { BaseFibonacciDataCacheTool } from "./BaseFibonacciDataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let FibonacciExpansionDataCacheTool = function ()
{
    BaseFibonacciDataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.FibonacciExpansion;
    this.InitPoints(3);
};

FibonacciExpansionDataCacheTool.prototype = Object.create(BaseFibonacciDataCacheTool.prototype);

FibonacciExpansionDataCacheTool.prototype.InitBlock = function ()
{
    BaseFibonacciDataCacheTool.prototype.InitBlock.apply(this);
    this.fibLevel = [61.8, 100, 161.8];
};

FibonacciExpansionDataCacheTool.prototype.MinPointsCount = function () { return 3; };
FibonacciExpansionDataCacheTool.prototype.MaxPointsCount = function () { return 3; };

//#region ICaller

FibonacciExpansionDataCacheTool.prototype.Properties = function ()
{
    var props = BaseFibonacciDataCacheTool.prototype.Properties.apply(this);

    props.push(new DynProperty("chart.tools.fibretr.fontcolor", this.FontColor, DynProperty.COLOR, DynProperty.VISUAL_GROUP));
    props.push(new DynProperty(Resources.getResource("EnableNegativeFibonacciValue"), true, DynProperty.BOOLEAN, /*DynProperty.FIBONACCI_PARAMETERS_GROUP*/DynProperty.HIDDEN_GROUP));

    var p = new DynProperty("Left ray",
        this.RayType === DataCacheToolRayType.LeftRay || this.RayType === DataCacheToolRayType.DoubleRay,
        DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP);
    p.sortIndex = 0;
    props.push(p);

    p = new DynProperty("Right ray",
        this.RayType === DataCacheToolRayType.RightRay || this.RayType === DataCacheToolRayType.DoubleRay,
        DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP);
    p.sortIndex = 1;
    props.push(p);

    return props;
};

FibonacciExpansionDataCacheTool.prototype.callBack = function (properties)
{
    BaseFibonacciDataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "chart.tools.fibretr.fontcolor");
    if (prop) this.FontColor = prop.value;

    prop = DynProperty.getPropertyByName(properties, "Ray style");
    if (prop) this.StyleRay = prop.value.Style;

    this.RayType = DataCacheTool.GetRayType(properties);
};

//#endregion